import * as React from 'react';
import { getDeviceId, getEnv, getNovadeUrl, getRegion, trackGotoNovadeLiteEvent } from '../utils/utils';
import background from '../assets/nl_skyline.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';
import { BrickAnimation } from '../components/BrickAnimation/BrickAnimation';
import { Profile } from '../components/types';

let hasInitRun = false;
const redirectTimeMs = 5000;

export const Success = () => {
  const params = useLocation();
  const novadeUrl = getNovadeUrl();
  const state = params.state as { profile?: Profile; apiUrl?: string } ?? {};
  const { profile, apiUrl } = state;
  const env = getEnv();
  const navigate = useNavigate();
 
  async function login(profile: Profile, apiUrl: string) {
    const region = getRegion(env, apiUrl);
    const response = await fetch(`${apiUrl}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        email: profile.email,
        password: profile.password,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Refresh token is stored in Cookie on web so we don't need to pass it as query parameter.
      const url = `${novadeUrl}/login-redirect?env=${env}&region=${region}`;
      return isMobile ? `${url}&refresh-token=${data.refreshToken}` : url;
    }
    
    return '';
  }

  async function init() {
    if (profile && apiUrl) {
      const deviceIDParams = getDeviceId(profile);
      trackGotoNovadeLiteEvent(profile); 
      const path = isMobile ? '/splash' : '';

      const autoLoginUrl = !profile.sso ? await login(profile, apiUrl) : '';

      const redirectUrl = profile.sso || autoLoginUrl === ''
        ? deviceIDParams ? `${novadeUrl}${path}?${deviceIDParams}` : `${novadeUrl}${path}`
        : deviceIDParams ? `${autoLoginUrl}&${deviceIDParams}` : autoLoginUrl;

      setTimeout(() => {
        if (isMobile) {
          window.open(redirectUrl);
        }
        window.location.replace(redirectUrl);
      }, redirectTimeMs);
    } else {
      // profile and apiUrl could be undefined if the user navigates to this page directly.
      // In this case, we redirect to the error page.
      navigate('/error', { replace: true });
    }
  }

  useEffect(() => {
    if (hasInitRun) return;
    hasInitRun = true;
    init();
  }, []);

  const backgroundStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'bottom',
    backgroundAttachment: 'fixed',
  };

  return <div className="App" style={backgroundStyle}>
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    ><BrickAnimation messageKey='workspace_loading'/>
    </div>
  </div>;
};
